module.exports = __webpack_public_path__ + "img/POST.2fd66db4.svg";